import React from 'react';
import { Fab, Badge, Box } from '@mui/material';
import { ShoppingCart as ShoppingCartIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useShopifyCart } from '../../hooks/useShopifyCart';

interface FloatingCartButtonProps {
  onClick: () => void;
}

export const FloatingCartButton: React.FC<FloatingCartButtonProps> = ({ onClick }) => {
  const theme = useTheme();
  const { itemCount } = useShopifyCart();

  // Don't show button if cart is empty
  if (itemCount === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1000,
      }}
    >
      <Badge
        badgeContent={itemCount}
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: theme.palette.error.main,
            color: 'white',
            fontWeight: 'bold',
            fontSize: '0.8rem',
            minWidth: 20,
            height: 20,
            borderRadius: '50%',
          },
        }}
      >
        <Fab
          color="primary"
          onClick={onClick}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
              transform: 'scale(1.05)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          <ShoppingCartIcon />
        </Fab>
      </Badge>
    </Box>
  );
};

export default FloatingCartButton; 